import styled, {css} from 'styled-components';
import SectionWrapper from '../SectionWrapper';
import Button from '../../global/Button';
import { queries } from "../../../breakpoints"

export const StyledCtaSection = styled(SectionWrapper)`
    text-align: center;
    display: flex;
    justify-content: center;
    position: relative;
    margin-top: ${props => props.topSpacing ? props.topSpacing : "48px" };
    margin-bottom: ${props => props.bottomSpacing ? props.bottomSpacing : "40px"};

  @media (${queries.max_break_md}) {
    margin-top: ${props => props.topSpacingMobile ? props.topSpacingMobile : "88px"};
    margin-bottom: ${props => props.bottomSpacingMobile ? props.bottomSpacingMobile : "80px"};
  }
  
  .container{
    position: relative;
    width: 100%;
    max-width: 100% !important;
    height: 100%;
    display: flex;
    justify-content: center;
    .container-cta{
      position: relative;
      justify-content: center;
      display: flex;
      flex-direction: column;
      align-items: center;
      z-index: 5;
      ${props => props.maxWidth && css`
      max-width: ${props.maxWidth};

        @media (${queries.max_break_md}) {
          padding: 40px 0;
        }

        [class*="Buttonstyles__StyledButton"] {
          color: #242E30;//var(--color-primaryNew);
          border-color: #242E30;//var(--color-primaryNew);
        }
    `}
    }
    .buttons-wrapper{
      display: flex;
      flex-direction: row;
      justify-content: center;
      gap: 20px;
      @media (${queries.max_break_md}) {
        flex-direction: column;
      }
    }
  }
  
  .gh-cta-graphic{
    position: absolute;
    z-index: 1;
    @media (${queries.max_break_md}) {
      &.graphic-hide {
        display: none;
      }
    }
  }
  .gh-cta-graphic-top{
    top: 0px;
    right: 0px;
    width: 497px;
    height: 699px;
    transform: translatey(calc(-50% - 34px));
    @media (${queries.max_break_md}) {
      width: 273px;
      height: 221px;
      background-position: center;
      background-size: cover;
    }
    
    ${ props => props.shrinkGraphicMobile ? css`

          @media (${queries.max_break_md}) {
            width: 181px !important;
            height: 181px !important;
            top: -20px !important;
          }
          
        ` : '' 
    }
    
  }
  .gh-cta-graphic-bottom{
    transform: translatey(calc(50% + 14px));
    bottom: 0px;
    left: 0px;
    width: 497px;
    height: 667px;
    @media (${queries.max_break_md}) {
      width: 261px;
      height: 211px;
      background-position: center;
      background-size: cover;
    }
    ${props => props.shrinkGraphicMobile ? css`

          @media (${queries.max_break_md}) {
                background-position: left top;
                width: 181px !important;
                height: 181px !important;
                bottom: -60px !important;
          }
          
        ` : ''
    }
  }
`;

export const Headline = styled.h2`
  font-family: var(--jetSansDigital-fontFamily); 
    margin-bottom:20px; 
      font-size: 36px;
      font-style: normal;
      font-weight: 800;
      line-height: normal;
  max-width: 460px;
`;
export const Subheadline = styled.p`
  font-family: var(--jetSansDigital-fontFamily);
    text-align: center;
    font-size: var(--fontSize-1);
    color: #242E30; 
  text-align: center;  
  font-style: normal;
  /*font-weight: 400;*/
  line-height: 150%; /* 24px */
  letter-spacing: -0.16px;
    max-width: 460px;
      @media (${queries.max_break_md}) {
        max-width: 320px;
      }
`;

export const LegalText = styled.p`
  font-family: var(--jetSansDigital-fontFamily);
    text-align: center;
    font-size: var(--fontSize-legal);
    color: #242E30;
  text-align: center;
  font-size: 10px;
  font-style: italic;
  font-weight: 400;
  line-height: 150%; /* 15px */
  letter-spacing: -0.1px;
    max-width: 444px;
  margin-top: 16px;
`;

export const Cta = styled(Button)`
    // Styles here are not working... Something in the Button setup is not allowing the styles to be extended
  
  font-family: var(--jetSansDigital-fontFamily);
`;
